import React, { useState, useEffect } from 'react';
import styles from './NumberRoll.module.scss';

const NumberRoll = ({ value, duration = 1000, className = '' }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const [prevValue, setPrevValue] = useState(0);

  useEffect(() => {
    if (value !== prevValue) {
      const startValue = prevValue;
      const endValue = value;
      const startTime = Date.now();

      const animate = () => {
        const now = Date.now();
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const currentValue = Math.round(
          startValue + (endValue - startValue) * easeOutQuart,
        );

        setDisplayValue(currentValue);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setDisplayValue(endValue);
          setPrevValue(endValue);
        }
      };

      requestAnimationFrame(animate);
    }
  }, [value, prevValue, duration]);

  //千位分隔符格式化toLocaleString

  return (
    <span className={`${styles.numberRoll} ${className}`}>
      {/* {displayValue.toLocaleString()} */}
      {displayValue}
    </span>
  );
};

export default NumberRoll;
